import { Component } from '@angular/core';
import { 
  ActionSheetController,
  NavController,
  NavParams, 
  Events 
} from 'ionic-angular';

// Providers
import { UsersService } from '../../providers/users/users-service';
import { HelperService } from '../../providers/helpers/helper-service';

@Component({
  selector: 'page-user-account',
  templateUrl: 'user-account.html'
})
export class UserAccountPage {
  headerData: any;
  user: any = {};
  context: string = 'user-account';
  edit: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    public actionSheetCtrl: ActionSheetController,
    public usersService: UsersService,
    public helperService: HelperService
  ) {
    this.context = this.navParams.get('context');
    if ( this.navParams.get('user') )
    {
      this.user = this.navParams.get('user');
      this.headerData = { title: 'Edit User' };
      this.edit = true;
    } else if ( this.context === 'user-manager' ) {
      this.headerData = { title: 'Add New User' };
    } else {
      this.headerData = { title: 'My Account' };
    }
  }

  saveUser()
  {
    this.usersService.saveUser( this.user )
      .subscribe( data => {
        this.events.publish('app:log', {
          message: 'User has been saved.',
          status: 'success',
          type: 'save user'
        });
        this.dismissPage();
      },
      error => {
        this.helperService.showErrors( error );
      }      
    );
  }

  deleteUser( user )
  {
    this.usersService.removeUserFromApp( user.user_id ).subscribe( data => {
      this.events.publish('app:log', {
        message: 'User has been deleted.',
        status: 'warning',
        type: 'delete user'
      });
      this.dismissPage();
      },
      error => {
        this.helperService.showErrors( error );
      }  
    );      
  }

  dismissPage()
  {
    this.navCtrl.pop();
  }

  presentDeleteUserActionSheet()
  {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Are you sure you want to delete this user?',
      buttons: [
        {
          text: 'Delete user',
          role: 'destructive',
          handler: () => {
            this.deleteUser( this.user );
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {}
        }
      ]
    });

    actionSheet.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-account/user-account.ts